import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import { Button, Modal, Calendar, Badge } from 'antd';
import CalendarMobile from 'react-calendar';
import classNames from 'classnames';
import moment from 'moment';

import { timeFormat, dateFormat } from 'utils/dates';

import MobileCell from './mobile-cell';
import BookingsDetailList from './bookings-detail-list';

import 'react-calendar/dist/Calendar.css';
import './style.css';

const dateCellRender = (value, bookings) => {
  const listData = bookings.filter((doc) => {
    const { dateStart, dateEnd } = doc.data();
    const d1 = moment.utc(dateStart);
    const d2 = moment.utc(dateEnd);
    const diff = d2.diff(d1, 'days')+1;
    
    // eslint-disable-next-line no-plusplus
    for (let i=0; i<diff; i++) {
      const day = d1.clone().add(i, 'days');
      const match = day.isSame(value, 'day');
      
      if (match) return true;
    }
    return moment.utc(dateStart).isSame(value, 'day');
  });

  return (
    <ul className="events">
      {listData.map((doc) => {
        const { dateStart, dateEnd } = doc.data();
        const startFormat = moment.utc(dateStart).format(timeFormat);
        const endFormat = moment.utc(dateEnd).format(timeFormat);
        return (
          <li key={doc.id}>
            <Badge
              status="success"
              text={`
                ${startFormat}-${endFormat}
              `}
            />
          </li>
        );
      })}
    </ul>
  );
};

const monthCellRender = (value, bookings) => {
  const listData = bookings.filter((doc) => {
    const { dateStart } = doc.data();
    return moment.utc(dateStart).isSame(value, 'month');
  });

  if (listData.length === 0) return null;

  return (
    <div className="notes-month">
      <span>
        <strong>{listData.length}</strong> bookings
      </span>
    </div>
  );
};

const getDateTitle = (date) => {
  if (!date) return '';
  const mDate = moment.utc(date);
  return mDate.format(dateFormat);
};

const BookingCalendar = ({ className, bookings, userKey }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const customClassName = classNames('booking-calendar', className);

  return (
    <Media
      queries={{
        small: '(max-width: 699px)',
        medium: '(min-width: 700px)',
      }}
    >
      {(matches) => (
        <>
          <Modal
            title={`Shifts for ${getDateTitle(selectedDate)}`}
            visible={modalVisible}
            onOk={() => {
              setModalVisible(false);
            }}
            onCancel={() => {
              setModalVisible(false);
            }}
            footer={<Button onClick={() => setModalVisible(false)}>Ok</Button>}
          >
            <BookingsDetailList
              date={selectedDate}
              bookings={bookings}
              userKey={userKey}
            />
          </Modal>
          {matches.small ? (
            <>
              <CalendarMobile
                minDetail="year"
                tileContent={({ date }) => {
                  return <MobileCell date={date} bookings={bookings} />;
                }}
                onClickDay={(value) => {
                  setSelectedDate(value);
                  setModalVisible(true);
                }}
              />
            </>
          ) : null}
          {matches.medium ? (
            <Calendar
              onSelect={(value) => {
                setSelectedDate(value);
                setModalVisible(true);
              }}
              className={customClassName}
              dateCellRender={(value) => {
                return dateCellRender(value, bookings);
              }}
              monthCellRender={(value) => {
                return monthCellRender(value, bookings);
              }}
            />
          ) : null}
        </>
      )}
    </Media>
  );
};

BookingCalendar.propTypes = {
  className: PropTypes.string,
  userKey: PropTypes.string.isRequired,
  bookings: PropTypes.arrayOf(
    PropTypes.shape({
      startDate: PropTypes.string,
      rate: PropTypes.number,
    })
  ).isRequired,
};

BookingCalendar.defaultProps = {
  className: null,
};

export default BookingCalendar;
